



































import { i18n } from "@/locales/settings";
import { Vue, Component } from "vue-property-decorator";
import Modal from "@/components/form/Modal.vue";
import CustomButton from "@/components/form/CustomButton.vue";
import { settingStorageApi } from "@/getinfo-api";
import { getCurrentCompanyId, getCurrentUserId } from "@/plugins/roles";
import { Setting as ISetting } from "@/api-v2/settings-storage/models";
import { newsSettings, News } from "@/services/notifications";
import { envVars } from "@/plugins/env-vars";

interface UpdateItem {
  title: string;
  body: string;
  created: string;
}

@Component({
  components: { CustomButton, Modal }
})
export default class WhatsNew extends Vue {
  lastVersionInDb: string | null = null;
  updates: Array<UpdateItem> = [];
  news: News<UpdateItem> = new News(newsSettings);

  get currentUser() {
    return getCurrentUserId();
  }

  get locale() {
    return i18n.locale;
  }

  get currentCompany() {
    return getCurrentCompanyId();
  }

  get checkHasNotification() {
    return (
      this.updates.length &&
      this.lastVersionInDb &&
      this.updates[0].title !== this.lastVersionInDb
    );
  }

  get currentVersion() {
    return envVars.getStr("VUE_APP_VERSION");
  }

  async updateHasUpdates() {
    this.lastVersionInDb = this.updates.length ? this.updates[0].title : "";

    let params: ISetting = {
      name: "lastVersionInDb",
      value: { value: this.lastVersionInDb }
    };

    await settingStorageApi.User.putUserSettings(this.currentUser, [params]);
  }

  async init() {
    try {
      await settingStorageApi.User.getUserSettings(this.currentUser, [
        "lastVersionInDb"
      ]).then((res: { data: any }) => {
        this.lastVersionInDb = res.data[0]?.value?.value;
      });
      const res = await this.news.getNews();
      if (res) {
        this.updates = res;
      }
    } catch (e) {
      console.error(e);
    }
  }

  mounted() {
    this.init();
  }
}
